import PropTypes from "prop-types";
import {valueFrom, valueFromTarget} from "lib/form";

function AdminReviewersForm({onChange, onSubmit, value}) {
  const dataValue = (name, defaultValue) => (
    valueFrom({
      defaultValue,
      name,
      objects: [value("data", {})]
    })
  );
  const onDataChange = ({target}) => {
    onChange({
      target: {
        name: "data",
        value: {...value("data", {}), [target.name]: valueFromTarget(target)}
      }
    });
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="col-md-4 offset-md-4">
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="record-email">Email</label>
            </div>
            <input
              className="form-control"
              id="record-email"
              name="email"
              onChange={onChange}
              placeholder="Email"
              type="email"
              value={value("email")}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="record-first-name">First Name</label>
            </div>
            <input
              className="form-control"
              id="record-first-name"
              name="first_name"
              onChange={onChange}
              placeholder="First Name"
              required={true}
              type="text"
              value={value("first_name")}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="record-last-name">Last Name</label>
            </div>
            <input
              className="form-control"
              id="record-last-name"
              name="last_name"
              onChange={onChange}
              placeholder="Last Name"
              required={true}
              type="text"
              value={value("last_name")}
            />
          </div>
          {[
            {id: "affiliation", label: "Affiliation", name: "affiliation"},
            {id: "degree", label: "Degree", name: "degree"},
            {id: "department", label: "Department", name: "department"},
            {id: "link", label: "Link", name: "link", type: "url"},
            {id: "location", label: "Location", name: "location"},
            {id: "title", label: "Title", name: "title"}
          ].map(({id, label, name, type}) => (
            <div key={name} className="input-group mb-3">
              <div className="input-group-prepend">
                <label className="input-group-text" htmlFor={`record-data-${id}`}>{label}</label>
              </div>
              <input
                className="form-control"
                id={`record-data-${id}`}
                name={name}
                onChange={onDataChange}
                placeholder={label}
                type={type || "text"}
                value={dataValue(name)}
              />
            </div>
          ))}
          <div className="form-group text-center">
            <button type="submit" className="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </form>
  );
}

AdminReviewersForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired
};

export default AdminReviewersForm;
